import { useQuery } from "@tanstack/react-query";
import { api } from "api";
import { useFetchStateHelper } from "hooks/useFetchState";

export const useEnemiesOfStress = (stressId) => {
  const { data: enemies, ...queryResponse } = useQuery({
    queryKey: ["enemies-of-stress", stressId],
    queryFn: () => api.stresses.fetchEnemies(stressId),
    enabled: !!stressId,
    select: ({ data }) => {
      if (!data) {
        return [];
      }
      const enemiesFlattened = [
        ...data.pathogens,
        ...data.insects,
        ...data.weeds,
        ...data.mineralImbalances,
      ];
      return enemiesFlattened;
    },
  });

  const { fetchState } = useFetchStateHelper(queryResponse);

  return { enemies, fetchState };
};
